import { Container, Typography } from "@mui/material";
import React, { useEffect } from "react";
import "./../CommonStyle.css";
import DownloadSection from "./../DownloadSection";
import { sendEvent } from "./../../Config/AnalyticsConfig";
import { Helmet } from "react-helmet";
import {
  style_pageTitle,
  style_pageTitle_mobile,
  style_contactUsText,
} from "../CommonStyle";

const ContactUs = () => {
  const isMobile = window.innerWidth <= 960;
  useEffect(() => {
    sendEvent(`contact_us_page_load`);
  }, []);

  return (
    <Container className="page-parent" sx={{ color: "#5e5c90" }}>
      <Helmet>
        <title>
        Contact Us | FirstCry PlayBees
        </title>
        <link
          rel="canonical"
          href="https://PlayBees.firstcry.com/contactus"
        />
        <meta
          name="keywords"
          content="educational, baby songs, baby games, kids games, toddler learning games, story book, read stories, puzzle, memory games, preschool, kindergarten, nursery rhymes"
        />
        <meta
          name="description"
          content="Get in touch with the FirstCry PlayBees team for support, feedback, or queries. We’re here to help you with all your app and learning experience needs."
        />
        <meta name="author" content="FirstCry PlayBees" />
      </Helmet>
      <Typography
        variant="h3"
        gutterBottom
        sx={isMobile ? style_pageTitle_mobile : style_pageTitle}
      >
        Contact Us
      </Typography>
      <Typography
        variant="body2"
        gutterBottom
        align="center"
        sx={style_contactUsText}
      >
        Brainbees Solutions Private Limited
      </Typography>
      <Typography
        variant="body2"
        gutterBottom
        align="center"
        sx={style_contactUsText}
      >
        114, Rajashree Business Park Nr. Sohrab Hall,
      </Typography>
      <Typography
        variant="body2"
        gutterBottom
        align="center"
        sx={style_contactUsText}
      >
        338, Tadiwala Rd, Sangamvadi, Pune, Maharashtra 411001
      </Typography>
      <Typography
        variant="body2"
        gutterBottom
        align="center"
        sx={style_contactUsText}
      >
        Email:
        <a
          href="mailto:playbees@firstcry.com"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            sendEvent(`contact_emailid_click`);
          }}
        >
          <u>playbees@firstcry.com</u>
        </a>
      </Typography>

      <DownloadSection />
    </Container>
  );
};

export default ContactUs;
